import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Space, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from '../../../services/AxiosInterceptor';

const DemoList = () => {
  const [list, setList] = useState();
  const navigate = useNavigate();

  const getDemoList = async () => {
    try {
      const response = await Axios.get("api/demo-list");
      const data = response.data;

      if (data.success) {
        const reverseData = Array.isArray(data.data) ? [...data.data].reverse() : data.data;
        setList(reverseData);
      }
    } catch (error) {
      console.error("Error fetching demo list:", error);
    }
  };

  useEffect(() => {
    getDemoList();
  }, []);

  const handleEdit = (record) => {
    navigate(`/edit-demo/${record._id}`);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this demo?")) {
      return;
    }

    try {
      const response = await Axios.post(
        "api/demo-list-delete",
        { id: id },
        {
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.data) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Session Type",
      dataIndex: "sessionType",
      key: "sessionType",
    },
    {
      title: "Class Mode",
      dataIndex: "classMode",
      key: "classMode",
    },
    {
      title: "Type",
      key: "type",
      render: () => {
        return (
          <span style={{ 
            backgroundColor: "#FFC107", 
            color: "white", 
            padding: "4px 12px", 
            borderRadius: "4px",
            fontWeight: "500"
          }}>
            Free Demo
          </span>
        );
      },
    },
    {
      title: "Location",
      render: (record) => {
        return record.locations?.map(loc => loc.name).join(", ");
      },
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button 
            icon={<EditOutlined />} 
            onClick={() => handleEdit(record)} 
            type="primary"
          >
            Edit
          </Button>
          <Button 
            icon={<DeleteOutlined />} 
            onClick={() => handleDelete(record._id)} 
            danger
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    navigate("/add-demo");
  };

  return (
    <div>
      <h3>Demo Lists</h3>
      <Button onClick={handleAdd} type="primary" style={{ marginBottom: '16px' }}>
        Add Demo
      </Button>

      <Table
        columns={columns} 
        dataSource={list}
        rowKey="_id" 
        pagination={false} 
      />
    </div>
  );
};

export default DemoList;
